import * as angular from 'angular';
import {IController} from "angular";

export class RelationsSubTableCtrl implements IController {
  relations: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('relationsSubTable', {
    bindings: {
      relations: '<'
    },
    template: require('./relations-sub-table.html').default,
    controller: RelationsSubTableCtrl
  });
